import ProjectCard from "../PageLayout/ProjectCard";
import { ProjectType } from "../Utils/ProjectType.ts";
import ProjectHeader from "./ProjectHeader";
import sharedStyles from "./shared.module.css";
import ProjectButton from "../Utils/ProjectButton.jsx";


export default function AutomataTutor () {




    return (
        <ProjectCard projectName={'Automata Tutor'}>

            <ProjectHeader title={"aUTOMATA tUTOR"} subTitle={"University of Liverpool 3rd Year Project"} projectType={ProjectType.Code} subTitleInfo={"I studied for a BSc in Computer Science at University of Liverpool, achieving a distinction."} />

            <p>
                <a href="https://github.com/AutomataTutor" target="_blank" rel="norefferrer noopener">Automata Tutor</a> is an online learning tool designed to teach <strong>Automata Theory</strong> and <strong>Formal Languages</strong> through interactive, teacher-assigned exercises.
            </p>

            <p>
                My contribution to the project, which also formed the basis of my dissertation, was adding new problem types to extend the system’s capabilities. 
            </p>

            <p>
                This was one of my first experiences with a major web development project and involved learning a lot of unfamiliar technologies including <strong>Scala</strong>’s equivalent of <strong>.NET MVC</strong>. I initially found it overwhelming, and I probably sound naïve in my technical explanation, but I did end up learning a lot and found the whole thing enjoyable (when it worked) and satisfying. 
            </p>

            <p>
                I haven’t worked with <strong>Scala</strong> much since this project, but I think the language has a really cool premise in trying to be <strong>declarative</strong> whilst also <strong>object-oriented</strong>. I’ll have to come back and try it in future projects!
            </p>

            <div class="videoWrapper">
                <iframe className={sharedStyles.video} src="https://www.youtube.com/embed/mk3xbvUFADw" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>

            <br />

            <div className={sharedStyles.links}>
                <ProjectButton link={"https://github.com/Portman123/automatatutor-frontend?"} name={"Frontend Code"} />

                <ProjectButton link={"https://github.com/Portman123/automatatutor-backend?"} name={"Backend Code"} />


                <ProjectButton link={"/documents/Automata-Tutor-Extension-Dissertation.pdf"} name={"Dissertation"} />

            </div>

        </ProjectCard>
    )
}